export default [
  {value: '1', label: '弱校验'},
  {value: '2', label: '免校验'}
]
